// extracted by mini-css-extract-plugin
export default {"text-orange":"CancelExpense_text-orange__w8gi4","text-center":"CancelExpense_text-center__mtnPy","md-reverse":"CancelExpense_md-reverse__x7pCs"};